/**
 * planaplana – Cart Quantity Stepper
 *
 * Ersetzt das Standard-Mengen-Eingabefeld + "Entfernen"-Link
 * durch einen +/− Stepper mit Inline-Bestätigung beim Versuch,
 * die Menge unter 1 zu reduzieren.
 *
 * Erweiterung: Cart-Drawer-Auto-Refresh nach Cart-Events. Maestrooo's
 * Recommendation-Add aktualisiert nur Cart-Total und Cart-Bubble,
 * lässt aber die Line-Items-Liste im offenen Drawer unverändert.
 * Wir hängen uns hier an die Cart-Events und laden das Drawer-Markup
 * nach jedem Cart-Change frisch nach.
 */
(function () {
  'use strict';

  function init() {
    document.addEventListener('click', onClick);
    setupCartDrawerAutoRefresh();
  }

  function onClick(event) {
    var btn = event.target.closest('.pl-qty__btn, .pl-qty__confirm-cancel');
    if (!btn) return;

    var stepper = btn.closest('.pl-qty');
    if (!stepper) return;

    if (btn.classList.contains('pl-qty__btn--minus')) {
      event.preventDefault();
      handleMinus(stepper);
    } else if (btn.classList.contains('pl-qty__btn--plus')) {
      event.preventDefault();
      handlePlus(stepper);
    } else if (btn.classList.contains('pl-qty__confirm-cancel')) {
      event.preventDefault();
      hideConfirm(stepper);
    }
  }

  function handleMinus(stepper) {
    var input = stepper.querySelector('.pl-qty__input');
    if (!input) return;

    var current = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 1;

    if (current > min) {
      setQuantity(input, current - 1);
      hideConfirm(stepper);
    } else {
      showConfirm(stepper);
    }
  }

  function handlePlus(stepper) {
    var input = stepper.querySelector('.pl-qty__input');
    if (!input) return;

    var current = parseInt(input.value, 10) || 1;
    var max = parseInt(input.max, 10);

    if (!isNaN(max) && current >= max) return;

    setQuantity(input, current + 1);
    hideConfirm(stepper);
  }

  function setQuantity(input, newValue) {
    input.value = newValue;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function showConfirm(stepper) {
    var confirmEl = stepper.querySelector('.pl-qty__confirm');
    if (confirmEl) confirmEl.hidden = false;
  }

  function hideConfirm(stepper) {
    var confirmEl = stepper.querySelector('.pl-qty__confirm');
    if (confirmEl) confirmEl.hidden = true;
  }

  /* ====================================================================
   * Cart-Drawer-Auto-Refresh
   * ====================================================================
   * Lädt das Cart-Drawer-Section-Markup und das Cart-Icon-Bubble nach jedem
   * Cart-Change neu. Wichtig, weil Maestrooo bei Recommendation-Adds
   * nur einen Teil der UI aktualisiert (Total, Bubble), nicht aber
   * die Line-Items-Liste im offenen Drawer.
   */
  var cartRefreshTimer = null;
  var cartRefreshInFlight = false;

  function refreshCartDrawer() {
    if (cartRefreshInFlight) return;
    cartRefreshInFlight = true;

    fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (sections) {
        if (!sections) return;

        if (sections['cart-drawer']) {
          var drawerSection = document.getElementById('shopify-section-cart-drawer');
          if (drawerSection) drawerSection.innerHTML = sections['cart-drawer'];
        }

        if (sections['cart-icon-bubble']) {
          var bubbleSection = document.getElementById('shopify-section-cart-icon-bubble');
          if (bubbleSection) bubbleSection.innerHTML = sections['cart-icon-bubble'];
        }
      })
      .catch(function (err) {
        console.warn('[pl] Cart-Drawer-Refresh fehlgeschlagen:', err);
      })
      .finally(function () {
        cartRefreshInFlight = false;
      });
  }

  function scheduleCartRefresh() {
    if (cartRefreshTimer) clearTimeout(cartRefreshTimer);
    cartRefreshTimer = setTimeout(refreshCartDrawer, 150);
  }

  function setupCartDrawerAutoRefresh() {
    // Maestrooo Impact theme dispatcht diverse Cart-Events.
    // Wir hängen uns an alle relevanten dran.
    document.addEventListener('cart:change', scheduleCartRefresh);
    document.addEventListener('cart:refresh', scheduleCartRefresh);
    document.addEventListener('cart:build', scheduleCartRefresh);
    document.addEventListener('on:cart:after-add', scheduleCartRefresh);
    document.addEventListener('on:cart:after-update', scheduleCartRefresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
